import { Button, Chip, Divider, Group, Stack, Text } from '@ekhodealer/ekho-common/rev';

/**
 * Applied filter item type for the applied filters section
 */
export type AppliedFilterItem = {
	id: string;
	title: string;
	value: string;
	clearFunction: () => void;
};

interface FiltersDrawerAppliedFiltersSectionProps {
	/** Array of currently applied filters */
	allAppliedFilters: AppliedFilterItem[];
	/** Function to clear all filters at once */
	clearAllFilters: () => void;
	/** Callback when a single filter is removed */
	onRemoveFilter: (filterId: string) => void;
}

/**
 * FiltersDrawerAppliedFiltersSection - A shared component for displaying applied filters
 *
 * This component provides a consistent UI for showing active filters as chips
 * with the ability to remove individual filters or clear all at once.
 */
export function FiltersDrawerAppliedFiltersSection({
	allAppliedFilters,
	clearAllFilters,
	onRemoveFilter,
}: FiltersDrawerAppliedFiltersSectionProps) {
	const totalAppliedCount = allAppliedFilters.length;

	// Don't render if no filters are applied
	if (totalAppliedCount === 0) {
		return null;
	}

	return (
		<Stack itemsSpacing='12'>
			<Group itemsAlignX='space-between' itemsAlignY='center' noWrap>
				<Text size='body' weight='semibold' align='left'>
					Applied filters ({totalAppliedCount})
				</Text>
				<Button variant='underlined' size='small' onPress={() => clearAllFilters()}>
					Clear all
				</Button>
			</Group>
			<Stack itemsSpacing='20'>
				<Group className='applied-filters-chips-group' itemsSpacing='8' itemsAlignX='start'>
					{allAppliedFilters.map((filter) => (
						<Chip
							key={filter.id}
							size='small'
							appearance='outline'
							onClose={() => onRemoveFilter(filter.id)}>
							{filter.value || filter.title}
						</Chip>
					))}
				</Group>
				<Divider />
			</Stack>
		</Stack>
	);
}
